import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormikContextType } from 'formik';
import { Box, Typography } from '@mui/material';
import FormikTextField from '../../components/formikComponents/FormikTextField';
import FormikRadioGroup from '../../components/formikComponents/FormikRadioGroup';
import { UIContext } from '../../context/UIContext';
import FormikPhoneNumber from '../../components/formikComponents/FormikPhoneNumber';
import useBusinessInformation from '../../helperHooks/useBusinessInformation';

const MFAForm = ({
  formik,
  mobileNumberError,
  setMobileNumberError,
  validMobileNumber,
  setValidMobileNumber,
  validLoginChannels,
  isSmsChannelOnly,
}: {
  formik: FormikContextType<any>;
  mobileNumberError: string;
  setMobileNumberError: (message: string) => void;
  validMobileNumber: boolean;
  setValidMobileNumber: (value: boolean) => void;
  validLoginChannels: { value: string; label: string }[];
  isSmsChannelOnly: boolean;
}) => {
  const { t } = useTranslation();
  const { isMobile } = useContext(UIContext);
  const { businessInformation } = useBusinessInformation();

  return (
    <>
      <Typography variant="h2">{t('screens.mfa.validation')}</Typography>
      <Typography variant="body1" sx={{ marginBottom: 2 }}>
        {t('screens.mfa.validationDescription')}
      </Typography>
      <FormikRadioGroup
        id="channel"
        formName="wizardMfa"
        name="channel"
        options={validLoginChannels}
        optionStyles={{ marginLeft: 0, paddingRight: 2, marginBottom: 2 }}
      />
      <Box
        sx={{
          width: '100%',
          ...(isSmsChannelOnly &&
            !isMobile && {
              width: '50%',
            }),
          display: 'flex',
          alignItems: 'flex-start',
          gap: '1rem',
          flexDirection: isMobile ? 'column' : 'row',
          '.MuiFormControl-root': {
            marginBottom: 0,
          },
        }}
      >
        {!isSmsChannelOnly && (
          <FormikTextField
            label={t('screens.mfa.email')}
            id="email"
            name="email"
            formName="wizardMfa"
            required={formik.values?.channel === 'email'}
            autoComplete="email"
            type="email"
          />
        )}
        <FormikPhoneNumber
          label={t('screens.mfa.mobileNumber')}
          id="mobileNumber"
          name="mobileNumber"
          type="tel"
          autoComplete="tel"
          formName="wizardMfa"
          required={formik.values?.channel === 'sms'}
          error={mobileNumberError}
          clearError={() => {
            setMobileNumberError('');
          }}
          setError={() => setMobileNumberError(t('validation.invalidMobileNumber'))}
          valid={validMobileNumber}
          setValid={setValidMobileNumber}
          defaultCountry={
            businessInformation?.country && businessInformation?.country?.length === 2
              ? businessInformation?.country?.toLowerCase()
              : 'gb'
          }
        />
      </Box>
    </>
  );
};

export default MFAForm;
